import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;

const stockTransferStore = {
  namespaced: true,
  actions: {
    getStockTransferList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stock/GetStockTransferList", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSOList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stocktransfer/getsolist", {
          entNum: param.entNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    copySODetails({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stocktransfer/copyso", {
          SONum: param.SONum,
          entNum: param.entNum,
          loc: param.loc
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getStockTransferHeaderByTxNum({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stocktransfer/gettxheader", {
          companyCode: common.getCompanyName(),
          txNumber: param.txNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getStockTransferDetailsByTxNum({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stocktransfer/gettxdetails", {
          companyCode: common.getCompanyName(),
          txNumber: param.txNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getEventCodeList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/SO/GetEventList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getRefSOList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stocktransfer/getrefsolist", {
          entNum: param.entNum,
          itemNum: param.itemNum
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addStockTransfer({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/stocktransfer/addstktxf",
          JSON.stringify({ txHdr: param.header, txDtlList: param.details })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    updateStockTransfer({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/stocktransfer/updatestktxf",
          JSON.stringify({ txHdr: param.header, txDtlList: param.details })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteStockTransfer({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/stocktransfer/deletestktxf",
          JSON.stringify({ txHdr: param.header })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    postStockTransfer({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/stocktransfer/poststktxf",
          JSON.stringify({ txHdr: param.header })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printTXF({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/stockTransfer/printstktxf",
          { txNum: param.txNum, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default stockTransferStore;
